export type ExecutionIncidentType =
  | 'downtime'
  | 'breakdown'
  | 'accident'
  | 'unload_refusal'
  | 'vehicle_change'
  | 'driver_change'
  | 'documents_wait'
  | 'date_reschedule'
  | 'partial_unload'
  | 'overload'
  | 'redirection'
  | 'other';

export type ExecutionIncidentStatus = 'open' | 'resolved';

export type ExecutionIncident = {
  id: number;
  routeId: number;
  incidentType: ExecutionIncidentType;
  status: ExecutionIncidentStatus;
  blockingFlag: boolean;
  comment: string | null;
  relatedExecutionStopUid: string | null;
  downtimeHours: number | null;
  extraCost: number | null;
  occurredAt: string;
  createdBy: number;
  resolvedAt: string | null;
  resolvedBy: number | null;
  resolutionComment: string | null;
  createdAt: string;
  updatedAt: string;
};

export const INCIDENT_TYPE_LABELS: Record<ExecutionIncidentType, string> = {
  downtime: 'Простой',
  breakdown: 'Поломка',
  accident: 'ДТП',
  unload_refusal: 'Отказ разгрузки',
  vehicle_change: 'Смена ТС',
  driver_change: 'Смена водителя',
  documents_wait: 'Ожидание документов',
  date_reschedule: 'Перенос даты',
  partial_unload: 'Частичная выгрузка',
  overload: 'Перегруз',
  redirection: 'Переадресация',
  other: 'Другое'
};

const BLOCKING_INCIDENT_TYPES = new Set<ExecutionIncidentType>([
  'downtime',
  'accident',
  'unload_refusal',
  'partial_unload',
  'documents_wait'
]);

export function getIncidentTypeLabel(type: ExecutionIncidentType): string {
  return INCIDENT_TYPE_LABELS[type] ?? type;
}

export function isBlockingIncidentType(type: ExecutionIncidentType): boolean {
  return BLOCKING_INCIDENT_TYPES.has(type);
}

export function getActiveBlockingIncidents(incidents: ExecutionIncident[]): ExecutionIncident[] {
  return incidents.filter((i) => i.status === 'open' && i.blockingFlag);
}

export function hasActiveBlockingIncidents(incidents: ExecutionIncident[]): boolean {
  return getActiveBlockingIncidents(incidents).length > 0;
}

export function formatIncidentSummary(incident: ExecutionIncident): string {
  const parts = [getIncidentTypeLabel(incident.incidentType)];
  if (incident.comment?.trim()) parts.push(incident.comment.trim());
  return parts.join(' — ');
}
